<template>
<div class="meet-pc-ph-items">
    <div class="meet-detail-pc">
        <div class="meet-detail-contaner">
            <div class="nav-crumb-top">
                <i class="wl-icon-zhuye1" style="color:#05243D;margin-right:8px;font-size:18px"></i>
                <span @click="goHome">首页</span>/
                <span @click="goTea">师资培训</span>/
                <span style="color:#05243D">{{ info.title }}</span>
            </div>
            <!-- <div class="meet-header">
                    当前位置：
                    <span @click="goback()" class="sp-meet-back">会议列表</span>
                    <span class="sp-head-line">></span>
                    <span class="meet-info-title">{{ info.title }}</span>
                </div> -->
            <div class="clearfix">
                <div class="meet-detail-fl fl">
                    <div class="meet-content-detail">
                        <div class="meet-top-info">{{ info.title }}</div>
                        <div class="meet-middle-info clearfix">
                            <div class="meet-img fl" v-if="info.meetingUrl != ''" :style="{ backgroundImage: 'url(' + info.meetingUrl + ')' }"></div>
                            <div class="meet-img fl" v-else :style="{ backgroundImage: 'url(' + meetImg + ')' }"></div>
                            <div class="meet-img-info fr clearfix">
                                <div class="meet-info-main clearfix">
                                    <div class="span-img clearfix">
                                        <div class="fl">
                                            <span>活动类型：</span>
                                            <span v-if="info.type == 1">
                                                <span v-if="info.meetingType == 1">师资培训</span>
                                                <span v-else-if="info.meetingType == 2">专业研讨</span>
                                                <span v-else-if="info.meetingType == 3">高层论坛</span>
                                                <span v-else>其它</span>
                                            </span>
                                            <span v-else-if="info.type == 2">1+X培训</span>
                                        </div>

                                        <div class="icon-wl fr">
                                            <i class="wl-icon-fenxiang icon"></i>
                                            <span class="span-lianjie icon">分享</span>
                                            <div class="wl-icon bg1">
                                                <i class="wl-icon-weixin icon-1"></i>
                                                <div class="er-img">
                                                    <qrcode-vue class="er-qrcode" :value="value" size="89" level="H" />
                                                    <div class="er-title">微信扫一扫</div>
                                                </div>
                                            </div>
                                            <a :href="shareLinkQq" class="wl-icon bg2" target="_blank" @click="getShareLink">
                                                <i class="wl-icon-qq1 icon-1"></i>
                                            </a>
                                            <a :href="shareLinkZone" class="wl-icon bg3" target="_blank" @click="getShareLink">
                                                <i class="wl-icon-QQkongjian icon-1"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="span-img">
                                        <span>活动地点：</span>
                                        <span>{{ info.address }}</span>
                                    </div>
                                    <div class="span-img">
                                        <span v-if="info.meetingType == '0'">培训起止时间:</span>
                                        <span v-else>报名起止时间：</span>
                                        <span>{{ info.startTime }} ~ {{ info.endTime }}</span>
                                    </div>
                                    <div class="span-img">
                                        <span>联系人：</span>
                                        <span>{{ info.contact }}</span>
                                    </div>
                                    <div class="meet-img-foot clearfix">
                                        <div class="fl sign-up-btn no-start-btn" v-if="info.state == 0" @click="noStart()">未开始</div>
                                        <div class="fl sign-up-btn start-sign-up-btn" v-else-if="info.state == 1" @click="nowSignUp(info.type, info.id)">
                                            立即报名
                                            <div class="arrow-val-con"></div>
                                            <div class="wx-scan-img-con">
                                                <qrcode-vue class="er-qrcode" :value="signUpValue" size="89" level="H" />
                                                <div class="er-title">手机扫一扫报名</div>
                                            </div>
                                        </div>
                                        <div class="fl sign-up-btn end-sign-up-btn" v-else @click="ending()">已结束</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="meet-step-con">
                            <p class="p-content-title">会议简介：</p>
                            <div class="meet-info-intro-con" v-html="info.content"></div>
                        </div>

                        <div class="meet-step-con">
                            <p class="p-content-title">会议流程如下：</p>
                            <p class="meet-step-title-1" v-html="info.explain"></p>
                        </div>

                        <div class="meet-step-con">
                            <p class="p-content-title">报名咨询</p>
                            <p class="meet-step-title-1">
                                <span>联系人：</span>
                                <span>{{ info.contact }}</span>
                            </p>
                            <p class="meet-step-title-1" style="margin-top:8px">
                                <span>联系电话：</span>
                                <span>{{ info.phone }}</span>
                            </p>
                        </div>
                        <div class="meet-step-con">
                            <p class="p-content-title">材料下载：</p>
                            <div v-if="speList.length > 0">
                                <div class="meet-step-material-list clearfix" v-for="(item, index) in speList" :key="index">
                                    <a :href="item.DocUrl" target="blank" :download="item.DocTitle" class="fl a-file-name-con">
                                        <i class="wl-icon-yuandianxiao1"></i>
                                        {{ item.DocTitle }}
                                    </a>
                                    <a :href="item.urlUpload" class="fl a-down-load">点击下载</a>
                                    <div class="fr file-scan-con" v-if="item.DocUrl != ''">
                                        <qrcode-vue class="er-qrcode" :value="item.DocUrl" size="100" level="H" />
                                        <p>手机扫码查看</p>
                                    </div>
                                </div>
                            </div>
                            <p v-else>暂无材料！</p>
                        </div>
                    </div>
                </div>
                <div class="meet-detail-fr fr">
                    <div class="meet-direct-info">最新会议</div>
                    <div class="meet-direct-ul-con">
                        <div class="meet-direct-items" v-for="(item, index) in list" :key="index" @click="jump(item.Id)">{{ item.Title }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="meet-detail-ph">
        <div class="crumbs-text">
            <div style="padding:0 10px;">
                <i style="color:#05243D" class="wl-icon-zhuye1"></i>
                <span @click="goHome" style="cursor: pointer;">首页</span>
                <span>></span>
                <span @click="goTea">师资培训</span>
                <span>></span>
                <span style="color:#05243D" class="ph-info-title">{{ info.title }}</span>
            </div>
        </div>
        <!-- <div class="ph-meet-location">
                <span class="sp-current-label">当前位置:</span>
                <span @click="goback()">会议列表</span>
                <span style="padding:0 6px">></span>
                <span class="ph-info-title">{{ info.title }}</span>
            </div> -->
        <div class="ph-img-items">
            <div class="ph-img-info">
                <div class="ph-img-title">{{ info.title }}</div>
                <div class="ph-img-content clearfix">
                    <div v-if="info.meetingUrl != ''" class="ph-meet-cover-img-con fl" :style="{ backgroundImage: 'url(' + info.meetingUrl + ')' }"></div>
                    <div class="ph-meet-cover-img-con fl" v-else :style="{ backgroundImage: 'url(' + meetImg + ')' }"></div>
                    <div class="ph-img-fr fr">
                        <div class="ph-span-img">
                            <span>活动类型：</span>
                            <span v-if="info.type == 1">
                                <span v-if="info.meetingType == 1">师资培训</span>
                                <span v-else-if="info.meetingType == 2">专业研讨</span>
                                <span v-else-if="info.meetingType == 3">高层论坛</span>
                                <span v-else>其它</span>
                            </span>
                            <span v-if="info.type == 2">1+X培训</span>
                        </div>
                        <div class="ph-span-img">
                            <span>活动地点：</span>
                            <span>{{ info.address }}</span>
                        </div>
                        <div class="ph-span-img">
                            <span v-if="info.meetingType == '0'">培训起止时间:</span>
                            <span v-else>报名起止时间：</span>
                            <span>{{ info.startTime }} ~ {{ info.endTime }}</span>
                        </div>
                        <div class="ph-span-img">
                            <span>联系人：</span>
                            <span>{{ info.contact }}</span>
                        </div>
                        <div class="ph-span-baoming bg1" v-if="info.state == 0" @click="noStart()">
                            <span class="ph-span-wenzi">未开始</span>
                        </div>
                        <div class="ph-span-baoming bg2" v-else-if="info.state == 1" @click="nowSignUp(info.type, info.id)">
                            <span class="ph-span-wenzi">立即报名</span>
                        </div>
                        <div class="ph-span-baoming bg3" v-else-if="info.state == 2" @click="ending()">
                            <span class="ph-span-wenzi">已结束</span>
                        </div>
                    </div>
                </div>
                <div class="ph-meet-step">
                    <div class="ph-meet-label">会议简介</div>
                    <div class="ph-meet-content" v-html="info.content"></div>
                </div>
                <div class="ph-meet-step">
                    <p class="ph-meet-label">会议流程如下：</p>
                    <p class="ph-meet-step-title-1" v-html="info.explain"></p>
                </div>
                <div class="ph-meet-step">
                    <p class="ph-meet-label">报名咨询</p>
                    <p class="ph-meet-step-title-1">
                        <span>联系人：</span>
                        <span>{{ info.contact }}</span>
                    </p>
                    <p class="ph-meet-step-title-1">
                        <span>联系方式:</span>
                        <span>{{ info.phone }}</span>
                    </p>
                </div>
                <div class="ph-meet-step">
                    <p class="ph-meet-label">材料下载：</p>
                    <div v-if="speList.length > 0">
                        <p class="ph-meet-material-con clearfix" v-for="(item, index) in speList" :key="index">
                            <a :href="item.DocUrl" :download="item.DocTitle" class="fl a-file-name-con">
                                <i class="wl-icon-yuandianxiao1"></i>
                                {{ item.DocTitle }}
                            </a>
                            <a :href="item.urlUpload" class="fr a-down-load">点击下载</a>
                        </p>
                    </div>
                    <p v-else>暂无材料！</p>
                </div>
            </div>
        </div>
    </div>
    <!-- 登陆弹窗 -->
    <newLogin :isShow="showObject"></newLogin>
</div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import newLogin from "components/newLogin.vue";
export default {
    data() {
        return {
            img8: require("assets/images/wlx-baic-bg-img.png"),
            value: "",
            teaShareLink: "",
            title: "",
            cover: "",
            desc: "",
            shareLinkZone: "",
            shareLinkQq: "",
            info: {},
            list: [],
            speList: [],
            count: 0,
            // meetImg: '',
            signUpValue: "",
            meetImg: require("assets/images/activity03.png"),
            meetUrl: "",
            shareDesc: "",
            showObject: {
                isShow: false,
            },
        };
    },
    components: {
        newLogin,
        QrcodeVue,
    },
    computed: {
        userInfo() {
            return this.$store.state.auth;
        },
    },
    created() {
        this.getSpecialInfo();
        this.top4MeetingList();
        this.value = document.location.href;
    },
    props: {
        meetId: {
            type: String,
            default: "",
        },
    },
    watch: {
        meetId() {
            this.getSpecialInfo();
            this.value = document.location.href;
            this.getShareLink();
        },
    },
    methods: {
        nowSignUp(type, id) {
            //  type 2:1 + x 培训 报名表 1:师资培训 2：专业研讨 3：高层论坛 4：其他
            if (this.userInfo.code > 0) {
                if (type == 2 || type == 0) {
                    this.$router.push({
                        name: "trainSignTables",
                        params: {
                            signUpId: id,
                            type: type,
                        },
                    });
                } else if (type == 1) {
                    this.$router.push({
                        name: "signUpTable",
                        params: {
                            signUpId: id,
                            type: type,
                        },
                    });
                }
            } else {
                
                this.beforeLogin();
            }
        },
        beforeLogin() {
            if ((navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i))) {
                //显示移动端的代码
                this.$router.push({
                    name: "phLogin"
                })
            } else {
                this.showObject = {
                    isShow: true,
                };
            }
        },
        noStart() {
            this.$message.warning("此会议未开始！");
            return false;
        },
        ending() {
            this.$message.warning("此会议已结束！");
            return false;
        },
        jump(id) {
            this.$router.push({
                name: "meetSignUpDetail",
                params: {
                    meetId: id,
                },
            });
        },
        //获取会议前四条数据
        top4MeetingList() {
            var that = this;
            this.$http.post("/api/XOrg/Special/top4MeetingList").then(function (rst) {
                if (rst.code > 0) {
                    that.list = rst.list;
                }
            });
        },
        //会议详情
        getSpecialInfo() {
            var that = this;
            this.$http
                .post("/api/XOrg/Special/getSpecialInfo", {
                    id: this.meetId,
                })
                .then(function (rst) {
                    let href = window.location.origin;
                    let type = rst.info.meetingType;
                    if (rst.code > 0) {
                        that.info = rst.info;
                        let fileListNew = [];
                        rst.list.forEach((val) => {
                            fileListNew.push({
                                urlUpload: "/api/XOrg/Special/downloadfile?fileKey=" + val.UploadUrl + "&filename=" + val.DocTitle,
                                DocTitle: val.DocTitle,
                                DocUrl: val.DocUrl,
                            });
                        });
                        that.speList = fileListNew;
                        console.log(that.speList);
                        that.count = rst.count;
                        // 扫码报名表格页面链接生成
                        if (type == "0") {
                            that.signUpValue = `${href}/trainSignTable/${rst.info.id}/0`;
                        } else if (type == "1" || type == "2" || type == "3") {
                            that.signUpValue = `${href}/signTable/${rst.info.id}/${type}`;
                        }
                        that.ToText(that.info.content);
                        that.getShareLink();
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        goHome() {
            this.$router.push({
                name: "xIndex",
            });
        },
        goTea() {
            this.$router.push({
                name: "teaTraining",
            });
        },
        ToText(HTML) {
            this.shareDesc = HTML.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, "")
                .replace(/<[^>]+?>/g, "")
                .replace(/\s+/g, " ")
                .replace(/ /g, " ")
                .replace(/>/g, " ");
        },
        getShareLink() {
            let teaUrl = window.location.origin;
            let teaShareLink = teaUrl;
            //QQ空间
            let newLink = "https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey" + "?url=" + teaShareLink + "&sharesource=qzone" + "&title=" + this.info.title;
            "&pics=" + this.info.meetingUrl + "&summary=" + this.shareDesc;
            //QQ
            let shareLinkQq = "http://connect.qq.com/widget/shareqq/index.html" + "?url=" + teaShareLink + "&sharesource=qzone" + "&title=" + this.title + "&pics=" + this.info.meetingUrl + "&summary=" + this.shareDesc;
            //&title=你的分享标题
            //&pics=你的分享图片
            //=你的分享描述信息"
            //&desc=你的分享简述
            this.shareLinkZone = newLink;
            this.shareLinkQq = shareLinkQq;
        },
    },
};
</script>

<style lang="scss"></style>
